import titleize from 'titleize'

/**
 * Returns flat structure of menu items which are in feeds_categories site config.
 * @param {String} currentSite
 * @param {Array} menuConfig
 * @returns {Array}
 */
const getRSSFeeds = (currentSite, menuConfig, feedsCategories) => {
  const getTitle = name => `${titleize(currentSite)} new ${name} items feed`

  const getFeedUrl = categoryUrl => {
    const urlSection = categoryUrl.split('/').pop()
    return `/feeds/new-${urlSection}-items.atom`
  }

  return (
    feedsCategories
      .map(feedCategory => {
        // Look for a category in menu config, return title and url if found
        for (let i = 0; i < menuConfig.length; i++) {
          if (menuConfig[i].url === feedCategory) {
            return {
              title: getTitle(menuConfig[i].name),
              url: getFeedUrl(menuConfig[i].url)
            }
          }

          // Searching second level of the menu
          if (menuConfig[i].children) {
            for (let j = 0; j < menuConfig[i].children.length; j++) {
              if (menuConfig[i].children[j].url === feedCategory) {
                return {
                  title: getTitle(menuConfig[i].children[j].name),
                  url: getFeedUrl(menuConfig[i].children[j].url)
                }
              }
            }
          }
        }
      })
      // remove feeds which were not found in menu config
      .filter(item => !!item)
      // Add general feed for whole site
      .concat([
        {
          title: `${titleize(currentSite)} new items feed`,
          url: `/feeds/new-${currentSite}-items.atom`
        }
      ])
  )
}

export default getRSSFeeds



// WEBPACK FOOTER //
// ./common/utils/getRSSFeeds.js